import { render, staticRenderFns } from "./RewardsHeader.vue?vue&type=template&id=6884993e&scoped=true&"
import script from "./RewardsHeader.vue?vue&type=script&lang=js&"
export * from "./RewardsHeader.vue?vue&type=script&lang=js&"
import style0 from "./RewardsHeader.vue?vue&type=style&index=0&id=6884993e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6884993e",
  null
  
)

export default component.exports